export default __webpack_public_path__ + "static/media/SLIDE_PARRA_5.759f9189.jpg";